import { useCallback } from 'react'
import { useNavigate, type NavigateOptions, type To } from 'react-router-dom'
import { useUnsavedChangesOptional } from '@/shared/lib/useUnsavedChanges'

/**
 * Navegação programática com confirmação de alterações não salvas (GuardedLink pattern).
 */
export function useGuardedNavigate() {
  const ctx = useUnsavedChangesOptional()
  const navigate = useNavigate()

  return useCallback(
    async (to: To, options?: NavigateOptions): Promise<boolean> => {
      if (ctx?.isDirty) {
        const shouldLeave = await ctx.confirmDiscard()
        if (!shouldLeave) {
          return false
        }
        ctx.setDirty(false)
        requestAnimationFrame(() => {
          navigate(to, options)
        })
        return true
      }

      navigate(to, options)
      return true
    },
    [ctx, navigate],
  )
}
